module.exports = function() {
  return new Worker(__webpack_public_path__ + "bdd0211e92f6f1aabbec.worker.js");
};